module.exports = __webpack_public_path__ + "img/oak-mask.4c0f4d1f.png";